export enum SessionInfoActionType {
  UpdateSessionInfo = 'sessionInfo/updateSessionInfo',
  SetIsLoading = 'sessionInfo/setIsLoading',
}
